// Animations //
const loading1 = require("./animations/loading/loader1.json");
const REG_01 = require("./animations/REG_01/REG_01.json");
const REG_02 = require("./animations/REG_02/REG_02.json");
const REG_03 = require("./animations/REG_03/REG_03.json");
const REG_04 = require("./animations/REG_04/REG_04.json");
const REG_05 = require("./animations/REG_05/REG_05.json");
const REG_06 = require("./animations/REG_06/REG_06.json");
const REG_07 = require("./animations/REG_07/REG_07.json");
const SUCCESS = require("./animations/SUCCESS/SUCCESS.json");

let options = {
  loading1,
  REG_01,
  REG_02,
  REG_03,
  REG_04,
  REG_05,
  REG_06,
  REG_07,
  SUCCESS
};

export { options };
